module.exports = __webpack_public_path__ + "img/selected6-min.9f76b6f0.png";